module.exports = __webpack_public_path__ + "img/small-1.e17ccb61.webp";